module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADoSURBVEhL7ZRJCsJAEEXjVhceweEqCoKK13Q4gOBeTyEIDhuJbt3q/9oFn04iaWMgizx4kK6qdCWd0qimkkzgBe7hgAHHDm4/l2+GkDWsHTOQlzN8BnqCuSm9AV+XTfwj8rEj4uYjBopiT1sahRvw5m8T8ZcG1P9gPbiAlp+7WDC2ATX68AY1RxljLgjdgOg6ywc8wiWcwgbMRG8kus7rGrZhKlpIdB3iBqa+iRYRXYfK40qgBUYXxlBz9Ao7sAntl695TloCS/pjymlZwbuTH9Qf0xnUBgeYwDb/5X+lBbUBp6umEkTRC7+on7PPSrDvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-plumbing/dark/24.png
// module id = 2356
// module chunks = 2